<template>
  <router-link :to="disabled ? '#' : to" class="category-card-link" :class="{ 'disabled': disabled }" @click="handleClick">
    <a-card class="category-card" :bordered="false">
      <div class="card-content">
        <div class="icon-wrapper">
          <span class="category-icon">{{ icon }}</span>
        </div>
        <div class="text-wrapper">
          <h3 class="category-title">{{ title }}</h3>
          <p class="category-description">{{ description }}</p>
        </div>
        <div v-if="badge" class="badge-wrapper">
          <a-tag :color="badgeColor" class="category-badge">{{ badge }}</a-tag>
        </div>
      </div>
    </a-card>
  </router-link>
</template>

<script>
import { message } from 'ant-design-vue'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    to: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: '📁'
    },
    badge: {
      type: String,
      default: ''
    },
    badgeColor: {
      type: String,
      default: 'blue'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(e) {
      if (this.disabled) {
        e.preventDefault()
        message.info('Bu bo\'lim hozircha ishga tushirilmagan')
      }
    }
  }
}
</script>

<style scoped>
.category-card-link {
  text-decoration: none;
  display: block;
  transition: transform 0.2s ease;
}

.category-card-link:hover {
  transform: translateY(-4px);
}

.category-card-link.disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.category-card-link.disabled:hover {
  transform: none;
}

.category-card {
  height: 100%;
  border-radius: 16px;
  background: var(--card-bg);
  border: 1px solid var(--border);
  transition: all 0.3s ease;
}

.category-card:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  border-color: var(--primary);
}

.card-content {
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
}

.icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: linear-gradient(135deg, var(--primary-light), var(--primary));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.category-icon {
  font-size: 24px;
  line-height: 1;
}

.text-wrapper {
  flex: 1;
  min-width: 0;
}

.category-title {
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 4px;
  color: var(--text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.category-description {
  font-size: 13px;
  color: var(--text-soft);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge-wrapper {
  flex-shrink: 0;
}

.category-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  margin: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .icon-wrapper {
    width: 40px;
    height: 40px;
  }

  .category-icon {
    font-size: 20px;
  }

  .category-title {
    font-size: 14px;
  }

  .category-description {
    font-size: 12px;
  }
}
</style>